import { supabase } from '@/lib/supabase/config';

export async function getProjectEntitlements(projectId: number) {
  const { data, error } = await supabase.rpc('get_project_entitlements', {
    p_project_id: projectId,
  });

  if (error) {
    throw new Error(error.message || 'Failed to fetch project entitlements');
  }

  if (!data) {
    return null;
  }

  return data;
}
